import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

const Deleteaccount = () => {
  const [users, setUsers] = useState([])

  const fetchUsers = async () => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);
        
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };
        
        fetch("https://api.experts4u.in/api/v1/deleteaccount/getdeleteaccount", requestOptions)
          .then((response) => response.json())
          .then((result) => {console.log(result)
            setUsers(result.data)
          })
          .catch((error) => console.error(error));
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const deleteUser = (id) => {
    
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);
        
        const requestOptions = {
          method: "DELETE",
          headers: myHeaders,
          redirect: "follow"
        };
        
        fetch(`https://api.experts4u.in/api/v1/deleteaccount/deletedeleteaccount/${id}`, requestOptions)
          .then((response) => response.json())
          .then((result) => {console.log(result)
            if(result.success){
              Swal.fire(
                'Deleted!',
                'Your deleteaccount has been deleted.',
                'success'
              )
              fetchUsers()
            }
          })
          .catch((error) => console.error(error));
      } catch (error) {
        console.error(error)
      }
    
  
}

  return (
    <div className="container-fluid py-5 mt-4">
    <div className="row justify-content-center">
      <div className="col-md-11">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>No.</th>
              <th>User Email</th>
              <th>Remove User</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td>
                <td>{user.email}</td>
                <td>
                  <button className="btn btn-danger" onClick={() => deleteUser(user._id)}>Remove</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  )
}

export default Deleteaccount